import { elizabethConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function ElizabethPage() {
  return <CityPageTemplate config={elizabethConfig} />;
}